import { GetLabelFn } from 'types';

interface BugSeverity {
  value: string;
  getLabel: GetLabelFn;

  color: string;
  order: number;
}

export const BUG_REPORT_SEVERITIES: BugSeverity[] = [
  {
    value: 'NOT_URGENT',

    getLabel: (t) => t('NOT_URGENT'),

    color: '#C4C4C4',

    order: 2,
  },

  {
    value: 'TIMELY',

    getLabel: (t) => t('TIMELY'),

    color: '#1560CE',

    order: 1,
  },

  {
    value: 'URGENT',

    getLabel: (t) => t('URGENT'),

    color: '#F3003A',

    order: 0,
  },
];
